import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";

export default function PaymentCancel() {
  return (
    <>
      <SEO title="Payment Cancelled" description="Your booking was not completed." path="/payment/cancel" />
      <section className="flex min-h-[70vh] items-center justify-center px-5 py-32">
        <div className="w-full max-w-lg rounded-3xl card-3d p-10 text-center" data-testid="payment-cancel-page">
          <XCircle className="mx-auto h-16 w-16 text-slate-300" />
          <h1 className="mt-6 font-display text-3xl font-bold text-navy">Checkout cancelled</h1>
          <p className="mt-3 text-slate-600">
            No charge was made. Your escape is still waiting whenever you're ready.
          </p>
          <Link
            to="/packages"
            data-testid="cancel-back-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-semibold text-primary-foreground btn-glow hover:scale-105"
          >
            Return to packages <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
